const { isArray } = Array;
export default isArray;